// extracted by mini-css-extract-plugin
export default {"container":"znjqdVf3cePzMFpjADoZ","image":"F6PL05J1jU2AV1mxGjhR","heading":"JjoD9SylQ0spWLOfxlo2","text":"m5dKHuSIF0VF4SJMByQe"};